/* eslint-disable react/prop-types,react/no-find-dom-node */
import { LANGUAGES, BLOG_LANGUAGES } from 'common/consts/languages';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LanguageService from 'services/Language.service';
import { inject, observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';
import Language from './Language';
import LanguagesWrapper from './LanguagesWrapper';
import LanguagesDropdownWrapper from './LanguagesDropdownWrapper';
import LanguagesButton from './LanguagesButton';
import LanguageFullWidthBar from './LanguageFullWidthBar';

@inject('windowStore', 'appStore')
@observer
@withRouter
class Languages extends Component {
  constructor() {
    super();
    this.state = { opened: false };
    this.dropDownButtonRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;

    this.clickReactionDispose = windowStore.onClickedAnywhere(({ target }) => {
      const { opened } = this.state;
      if (!this.dropDownButtonRef.current.contains(target) && opened) {
        this.toggleDropDown();
      }
    });

    this.scrollReactionDispose = windowStore.reactToScroll(() => {
      const { opened } = this.state;
      if (opened) {
        this.setState({ opened: false });
      }
    });
  }

  componentWillUnmount() {
    this.clickReactionDispose();
    this.scrollReactionDispose();
  }

  @Bind
  toggleDropDown() {
    const { opened } = this.state;
    this.setState({ opened: !opened });
  }

  changeLanguage(e, language, pathname) {
    e.preventDefault();
    const { history } = this.props;
    const path = LanguageService.createLink(language, pathname);
    history.push(path);
  }

  render() {
    const {
      windowStore: { isOnTablet },
      appStore: { currentLanguage, currentUrl },
      location: { pathname },
    } = this.props;
    const { opened } = this.state;
    const isLangButtonVisible = !currentUrl.includes('/blog/');
    const isFrenchAvailable = !currentUrl.includes('/blog');
    const filteredLanguages = isFrenchAvailable ? LANGUAGES : BLOG_LANGUAGES;
    return (
      <LanguagesDropdownWrapper innerRef={this.dropDownButtonRef}>
        {!isOnTablet && isLangButtonVisible && (
          <LanguagesButton onClick={() => this.toggleDropDown()} />
        )}

        <LanguagesWrapper visible={opened}>
          <LanguageFullWidthBar visible={opened} />
          {Object.values(filteredLanguages).map(language => (
            <Language
              key={language.value}
              active={currentLanguage === language.value}
              onClick={e => this.changeLanguage(e, language.value, pathname)}
              href={LanguageService.createLink(language.value, pathname)}
            >
              {language.name}
            </Language>
          ))}
        </LanguagesWrapper>
      </LanguagesDropdownWrapper>
    );
  }
}

export default Languages;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/index.jsx